'use client';

import type { ListCollection } from '@ark-ui/react';
import { useTranslations } from 'next-intl';
import { SettingsEditDialog } from '../../settings/SettingsEditDialog';
import { useDraftOnOpen } from '../../application-general/useDraftOnOpen';
import { ExternalNetworkSettingsSelectField } from './ExternalNetworkSettingsSelectField';
import type { ExternalNetworkSettingsSelectItem } from './external-settings.model';

export type ExternalNetworkScanProfileDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  scanProfileId: string;
  collection: ListCollection<ExternalNetworkSettingsSelectItem>;
  isUpdating: boolean;
  onSubmit: (scanProfileId: string) => Promise<boolean>;
};

export function ExternalNetworkScanProfileDialog({
  open,
  onOpenChange,
  scanProfileId,
  collection,
  isUpdating,
  onSubmit,
}: ExternalNetworkScanProfileDialogProps) {
  const t = useTranslations(
    'designSystem.networkSettings.externalSettings.scanning',
  );
  const [draft, setDraft] = useDraftOnOpen({ open, value: scanProfileId });

  return (
    <SettingsEditDialog
      open={open}
      title={t('editScanProfileTitle')}
      onOpenChange={onOpenChange}
      onSubmit={() => {
        if (!draft) {
          return;
        }

        void onSubmit(draft).then((ok) => ok && onOpenChange(false));
      }}
      loading={isUpdating}
    >
      <ExternalNetworkSettingsSelectField
        label={t('scanProfile')}
        collection={collection}
        value={draft}
        onValueChange={setDraft}
      />
    </SettingsEditDialog>
  );
}
